import { render } from "./CalificacionesBoletaPage.vue?vue&type=template&id=59ae9af4"
import script from "./CalificacionesBoletaPage.vue?vue&type=script&lang=js"
export * from "./CalificacionesBoletaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__